import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';
import { environment } from '../../../environments/environment';

export interface DonationTier {
  amount: number;
  label: string;
  impact: string;
  icon: string;
}

@Component({
  selector: 'app-donate',
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.css']
})
export class DonateComponent implements OnInit {
  selectedAmount: number = 50;
  customAmount: number | null = null;
  donorName: string = '';
  donorEmail: string = '';
  donorMessage: string = '';
  dedicationType: string = 'none';
  dedicationName: string = '';
  isProcessing: boolean = false;
  success: boolean = false;

  donationTiers: DonationTier[] = [
    {
      amount: 25,
      label: 'Seedling Supporter',
      impact: 'Supplies native plants and organic soil for our Choctaw Medicine Wheel and Three Sisters Gardens.',
      icon: 'local_florist'
    },
    {
      amount: 50,
      label: 'Education Sponsor',
      impact: 'Covers full museum admission and learning materials for an entire local public school class.',
      icon: 'school'
    },
    {
      amount: 100,
      label: 'Preservation Guardian',
      impact: 'Purchases acid-free archival storage boxes, sleeves, and humidistats to protect historic bayou documents.',
      icon: 'inventory_2'
    },
    {
      amount: 250,
      label: 'Landmark Benefactor',
      impact: 'Directly funds architectural preservation and climate-control care of the 1912 wooden schoolhouse.',
      icon: 'foundation'
    }
  ];

  get currentTotal(): number {
    if (this.customAmount && this.customAmount > 0) {
      return this.customAmount;
    }
    return this.selectedAmount;
  }

  get mailtoLink(): string {
    const subject = encodeURIComponent(`Donation Pledge - Bayou Lacombe Museum ($${this.currentTotal})`);
    const dedicationInfo = this.dedicationType !== 'none' && this.dedicationName
      ? `\nDedication: In ${this.dedicationType} of ${this.dedicationName}`
      : '';
    const body = encodeURIComponent(
      `Hello Bayou Lacombe Museum Board,\n\nI would like to support the museum with a donation of $${this.currentTotal}.\n\nDonor Name: ${this.donorName || 'Supporter'}\nDonor Email: ${this.donorEmail || ''}${dedicationInfo}\nDonor Note: ${this.donorMessage || 'Support for museum preservation'}\n\nPlease let me know the best method to send funds (check by mail, Stripe invoice, or credit card).\n\nThank you for preserving Lacombe history!\n\nBest regards,\n${this.donorName || 'A Bayou Lacombe Supporter'}`
    );
    return `mailto:bayoulacombemuseum@gmail.com,info@bayoulacombemuseum.com?subject=${subject}&body=${body}`;
  }

  constructor(
    public nav: NavbarService,
    private seo: SeoService
  ) {}

  ngOnInit(): void {
    this.nav.show();
    this.seo.updateTags({
      title: 'Support History: Donate to Bayou Lacombe Museum',
      description: 'Your tax-deductible donation directly protects the 1912 wooden schoolhouse, provides free educational tours for school children, and preserves Choctaw cultural heritage.',
      url: '/donate'
    });
  }

  selectTier(amount: number): void {
    this.selectedAmount = amount;
    this.customAmount = null;
  }

  onCustomAmountInput(event: any): void {
    const val = parseFloat(event.target.value);
    if (!isNaN(val) && val > 0) {
      this.customAmount = val;
      this.selectedAmount = 0;
    }
  }

  submitPledge(): void {
    this.success = true;
  }
}
